<template>
  <div
    class="search-wrapper"
    :class="{
      'is-mini': isFolded && !isBig,
      'is-big': isBig,
      'mini-size': size == 'mini',
    }"
    data-io-click="tracker"  @click="jumpSearchPage"
  >
    <div class="search-box" :class="{ active: searchWord }">
      <i slot="suffix" data-io-click="tracker"  @click="handleSubmit" class="iconfont icon-sousuon"></i>
      <input
        v-if="(!isFolded || (isFolded && isBig)) && size == 'large'"
        id="top-search-input"
        :placeholder="placeHolderText"
        autocomplete="off"
        disableautocomplete
        class="search-text"
        v-model="searchWord"
        @input="handleInput"
        @keyup.enter="handleSubmit"
        @focus="handleFocus"
        ref="searchInput"
        type="text"
      />
      <span v-if="size == 'mini'">搜索</span>
      <!-- <button class="search-btn" data-io-click="tracker"  @click="handleSubmit">搜索</button> -->
    </div>
    <ul
      ref="historyBox"
      class="history-box"
      v-if="showHistoryBox && searchTipList.length && !isFolded"
    >
      <div
        v-for="(item, index) in searchTipList"
        :key="index"
        v-if="item.showText"
      >
        <p
          class="history-tip"
          v-if="!searchWord.length && !item.isHot && item.index == 1"
        >
          <span> 历史记录</span>
          <span data-io-click="tracker"  @click="handleClearHistory" class="clear-icon">清除历史</span>
        </p>
        <p
          class="hot-tip"
          v-if="item.isHot && item.index == 1"
          :class="{ 'border-top': searchHistory.length > 0 }"
        >
          <span>热词搜索</span>
        </p>
        <li
          data-io-click="tracker"  @click="jumpSearchResultList(item)"
          :name="
            item.isHot
              ? 'outter_search_hot_' + item.index
              : 'outter_search_history_' + item.index
          "
          :class="{ active: selectIndex == index }"
        >
          <i
            class="iconfont"
            :class="[
              item.isHot ? 'icon-hot1' : 'icon-search',
              item.index <= 3 ? 'active' : '',
            ]"
          ></i>
          <span v-html="item.showText"></span>
        </li>
      </div>
      <!-- && searchTipList.length > 0 -->
      <!-- <div
          v-for="(item, index) in searchTipList"
          :key="index"
          v-if="item.showText"
        >
          <p v-if="!searchWord.length && !item.isHot && item.index == 1">
            <span> 历史记录</span>
            <span data-io-click="tracker"  @click="handleClearHistory" class="clear-icon">清除历史</span>
          </p>
          <p v-if="item.isHot && item.index == 1"><span>热词搜索</span></p>
          <li
            data-io-click="tracker"  @click="jumpSearchResultList(item)"
            :class="{ active: selectIndex == index }"
          >
            <i
              class="iconfont"
              :class="[
                item.isHot ? 'icon-hot1' : 'icon-search',
                item.index <= 3 ? 'active' : '',
              ]"
            ></i>
            <span v-html="item.showText"></span>
          </li>
        </div> -->

      <!-- <div class="hot-list" v-if="!searchWord.length">
          <p><span>热词搜索</span></p>
          <li
            v-for="(item, index) in hotSearchWords"
            :key="index"
            data-io-click="tracker"  @click="jumpSearchResultList(item)"
          >
            <i class="iconfont icon-hot1"></i>
            {{ item }}
          </li>
        </div> -->
    </ul>
  </div>
</template>
<script>
import api from "@/assets/js/service/api";
import request from "@/utils/request";
import Cookie from "js-cookie";
import { mapState, mapMutations } from "vuex";
const SEARCHHISTORY = "SEARCHHISTORY";
let stop = null;
export default {
  props: {
    isShowInput: {
      type: Boolean,
      default: true,
    },
    isBig: {
      type: Boolean,
      default: false,
    },
    placeHolderText: {
      type: String,
      default: "输入搜索关键词",
    },
    size: {
      type: String,
      default: "large",
    },
  },
  data() {
    return {
      searchWord: "",
      // 搜索提示列表
      searchTipList: [],
      showHistoryBox: false,
      selectIndex: -1,
      // 热词列表
      hotSearchWords: [],
      // 历史记录列表
      searchHistory: [],
    };
  },
  filters: {
    showName(value) {
      return value;
    },
  },
  computed: {
    ...mapState(["currentCourse", "isFolded", "showSearchBoxTip"]),
  },
  watch: {
    searchWord(val) {
      if (!val) {
        //   // 解决当清空的时候上一次的结果还没出来就清空了所以清空的时候先终止上一次的
        if (stop) {
          stop();
        }
      }
      //   this.showHistoryBox = false;
      //   this.searchTipList = [];
      // } else {
      // this.showHistoryBox = Boolean(val.length);
      this.selectIndex == -1 && this.querySearch(this.searchWord);
      // }
    },
  },
  mounted() {
    this.selectIndex = -1;
    document.addEventListener("mouseup", this.mouseUp);
    // document.addEventListener("mouseleave", this.mouseLeave);
    // 监听上下键
    this.$nextTick(() => {
      document.addEventListener("keyup", this.keyUp); //创建监听键盘事件
      this.$refs.searchInput && this.$refs.searchInput.blur();
    });
  },
  destroyed() {
    document.removeEventListener("mouseup", this.mouseUp);
    // document.removeEventListener("mouseleave", this.mouseLeave);
    document.removeEventListener("keyup", this.keyUp);
    this.searchTipList.length = 0;
  },
  methods: {
    ...mapMutations(["changeShowSearchBoxTip"]),
    // 清楚历史记录
    handleClearHistory() {
      // 清楚缓存
      Cookie.remove(SEARCHHISTORY);
      this.querySearch("");
    },
    jumpSearchPage() {
      if (this.size == "mini") {
        this.$router.push("/search");
      }
    },
    jumpSearchResultList(item) {
      let { stageId, subjectId } = this.currentCourse;
      this.showHistoryBox = false;
      this.selectIndex = -1;
      this.addSearchHistory(item.text);
      this.$router.push(
        `/search/result/?title=${item.text}&pageSize=30&pageIndex=1&stageId=${stageId}&subjectId=${subjectId}`
      );
    },
    handleFocus() {
      // console.log("鼠标聚焦");
      if (this.showSearchBoxTip) {
        this.changeShowSearchBoxTip(false);
      }
      this.querySearch(this.searchWord);
    },
    handleInput(e) {
      // 获取输入词相关的关键词
      this.selectIndex = -1;
      // if (this.searchWord.length > 0) {
      //   this.querySearch(this.searchWord);
      // }
    },
    mouseLeave(e) {
      // console.log("鼠标离开");
      // this.showHistoryBox = false;
    },
    mouseUp(e) {
      e = e || window.event;
      let target = e.target;
      let historyBox = this.$refs.historyBox;
      let searchInput = this.$refs.searchInput;
      let topSearchInput = document.getElementById("top-search-input");
      if (
        (historyBox && historyBox.contains(target)) ||
        target == historyBox ||
        target == searchInput ||
        topSearchInput == target
      ) {
        this.showHistoryBox = true;
      } else {
        this.showHistoryBox = false;
        this.searchTipList = [];
      }
      // console.log("是否显示搜索框", this.showHistoryBox);
    },
    keyUp(e) {
      if (e.target != this.$refs.searchInput) {
        return;
      }
      if (e.keyCode == 40) {
        // 下键盘
        if (this.selectIndex >= this.searchTipList.length - 1) {
          this.selectIndex = 0;
        } else {
          this.selectIndex = this.selectIndex + 1;
        }
      } else if (e.keyCode == 38) {
        // 上键盘
        if (this.selectIndex == 0) {
          this.selectIndex = this.searchTipList.length - 1;
        } else {
          this.selectIndex = this.selectIndex - 1;
        }
      }
      this.selectIndex >= 0
        ? (this.searchWord = this.searchTipList[this.selectIndex].text)
        : null;
    },
    setBlur() {
      //  在点击由 clearable 属性生成的清空按钮时，主动触发失去焦点，解决‘fetch-suggestions’输入建议不提示的bug
      document.activeElement.blur();
    },
    filterSearchName(value) {
      const reg = new RegExp(this.searchWord, "g");
      return value.replace(reg, `<i class='key'>${this.searchWord}</i>`);
    },
    async querySearch(searchWord) {
      if (stop) {
        // console.log("清除上一次的请求", stop);
        stop();
      }
      const status = {
        clear: false,
      };
      stop = () => {
        status.clear = true;
      };
      // console.log("searchWord", searchWord);
      // this.showHistoryBox = true;
      let searchHistory = Cookie.get(SEARCHHISTORY) || [];
      // let hotSearchWords = [];
      if (!searchHistory.length) {
        Cookie.set(SEARCHHISTORY, JSON.stringify([]));
      } else {
        searchHistory = JSON.parse(decodeURIComponent(searchHistory));
      }
      if (!searchWord.length) {
        // console.log("currentCourse", this.currentCourse);
        let { stageId, subjectId } = this.currentCourse;
        let data = await request.postJson(api.search.hotSearchSite, {
          size: 5,
          stageId,
          subjectId,
        });
        this.hotSearchWords = data.result.slice(0, 5) || [];
        this.hotSearchWords = this.hotSearchWords.map((item, index) => {
          return {
            showText: item,
            text: item,
            isHot: true,
            index: index + 1,
          };
        });
        // 显示对应的历史记录
        let isSearchResultPage =
          this.$route.path.indexOf("/search/result") > -1;
        if (isSearchResultPage) {
          let currentSearchWord =
            this.$route.query && this.$route.query.title
              ? this.$route.query.title
              : "";
          searchHistory = searchHistory.filter(
            (item) => item != currentSearchWord
          );
        }
        searchHistory = searchHistory.map((item, index) => {
          const reg = new RegExp(this.keyword, "g");
          return {
            showText: item
              ? item.replace(reg, `<i class='key'>${searchWord}</i>`)
              : "",
            text: item,
            // 是否是热词
            isHot: false,
          };
        });
        this.searchHistory = searchHistory;
        // this.searchHistory = searchHistory;
        this.searchTipList = searchHistory
          .reverse()
          .slice(0, 5)
          .map((item, index) => {
            item.index = index + 1;
            return item;
          })
          .concat(this.hotSearchWords);
        return;
      }
      if (searchWord.length > 0) {
        let recommendList = [];
        let data = await request.get(api.search.searchRecommends, {
          content: encodeURIComponent(searchWord),
        });
        const reg = new RegExp(searchWord, "g");
        recommendList = data.result.map((item) => {
          return {
            showText: item.replace(reg, `<i class='key'>${searchWord}</i>`),
            text: item,
          };
        });
        // console.log("当前请求的状态", status.clear, searchWord);
        if (!status.clear) {
          this.searchHistory = [];
          // this.searchHistory = [];
          // console.log("recommendList", recommendList);
          this.searchTipList = recommendList;
        }
      }
      // }
    },
    // 提交跳转
    handleSubmit() {
      this.searchTipList.length = 0;
      if (this.isFolded || !this.searchWord.length) {
        this.$router.push("/search/");
      } else {
        if (this.searchWord.length > 0) {
          this.showHistoryBox = false;
          this.$refs.searchInput.blur();
          this.addSearchHistory(this.searchWord);
          this.selectIndex = -1;
          let { stageId, subjectId } = this.currentCourse;
          // console.log('currentCourse',this.currentCourse)
          this.$router.push(
            `/search/result/?title=${this.searchWord}&pageSize=30&pageIndex=1&stageId=${stageId}&subjectId=${subjectId}`
          );
        } else {
          this.$message("请输入搜索关键字");
        }
        this.searchWord = "";
      }
    },
    addSearchHistory(keyword) {
      let searchHistory = Cookie.get(SEARCHHISTORY) || [];
      if (searchHistory.length > 0) {
        searchHistory = JSON.parse(decodeURIComponent(searchHistory));
      }
      let findIndex = searchHistory.findIndex((item) => {
        return keyword == item;
      });

      if (findIndex == -1) {
        searchHistory.push(keyword);
        Cookie.set(SEARCHHISTORY, JSON.stringify(searchHistory));
      }
    },
    handleSelect(item) {
      this.setBlur();
      // return;
      if (item && (item.value == "无匹配结果" || !item.value)) {
        this.searchWord = "";
        return;
      }
      let { stageId, subjectId } = this.currentCourse;
      this.searchWord = "";
      // return;
      // this.searchWord = "";
      this.$router.push(
        `/search/result/?title=${item.value}&pageSize=30&pageIndex=1&stageId=${stageId}&subjectId=${subjectId}`
      );
    },
  },
};
</script>
<style scoped lang="scss">
.search-wrapper {
  // position: absolute;
  // top: 13px;
  // right: 94px;
  position: relative;
  padding: 0 12px;

  .search-box {
    position: relative;
    height: 36px;
    border-radius: 6px;
    right: 0px;
    bottom: 0px;
    // line-height: 1;
    // background: #fff;
    z-index: 2;
    border: 1px solid #eeeeee;
    padding: 0 10px;

    i {
      color: #bababa;
      display: inline-block;
      font-size: 16px;
      margin-right: 8px;
      vertical-align: top;
      margin-top: 10px;
    }

    .search-text {
      height: 100%;
      width: calc(100% - 24px);
      background: transparent;

      &::-webkit-input-placeholder {
        color: #bababa;
        font-size: 13px;
      }
    }
  }

  &.is-mini {
    padding: 0 12px;

    .search-box {
      padding: 0;
      text-align: center;

      i {
        margin-right: 0px;
      }
    }
  }
  &.mini-size {
    cursor: pointer;
    .search-box {
      // text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid #d5d9e5;
      i {
        margin-top: 0;
        margin-right: 0;
        color: #7e7e7e;
      }
      span {
        font-size: 12px;
        margin-left: 4px;
        color: #7e7e7e;
      }
    }
  }
  &.is-big {
    padding: 0;
    .search-box {
      width: 300px;
      background: #fff;
      border: none;
      border-radius: 6px;
      height: 32px;
      padding: 0 8px;
      i {
        margin-top: 8px;
      }
    }
    &.history-box {
      top: 38px;
    }
  }
  .search-input {
    width: 280px;
    height: 36px;
    box-sizing: border-box;
    // background: #ffffff;
    background: #eff1f4;
    border: 1px solid transparent;
    border-radius: 18px;
    display: flex;
    align-items: center;
    margin-top: 13px;

    input {
      flex: 1;
      background: #eff1f4;
      outline: none;
      height: 100%;
      padding-left: 18px;
      box-sizing: border-box;
      border-radius: 18px;

      &::-webkit-input-placeholder {
        color: #80848b;
        font-size: 14px;
        // padding: 18px;
      }

      // &.active{
      //    border: 1px solid #0052d9;
      // }
    }

    .icon-search {
      color: #0052d9;
      cursor: pointer;
      margin-right: 16px;
    }

    &:hover {
      border-color: #409eff;
      border: 1px solid #0052d9;
      background: #fff;

      // outline: 0;
      input {
        background: #fff;
      }
    }

    &.active {
      border-color: #409eff;
      border: 1px solid #0052d9;
      background: #fff;

      input {
        background: #fff;

        &::-webkit-input-placeholder {
          color: #333;
          font-size: 14px;
          // padding: 18px;
        }
      }
    }

    ::v-deep .el-input__suffix {
      .el-input__suffix-inner {
        .icon-search {
          font-size: 18px;
          margin-right: 16px;
        }
      }
    }
  }

  .history-box {
    width: 300px;
    position: absolute;
    top: 36px;
    max-height: 574px;
    background: #ffffff;
    // box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
    //   0px 16px 24px 2px rgba(0, 0, 0, 0.04),
    //   0px 8px 10px -5px rgba(0, 0, 0, 0.08);
    // border-radius: 4px;
    padding: 17px 0;
    padding-bottom: 0px;
    // margin-top: 8px;
    overflow: hidden;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.06);
    border-radius: 0px 0px 4px 4px;
    border: 1px solid #e6e7e9;
    overflow-y: auto;
    z-index: 2000;

    li {
      margin-bottom: 6px;
      cursor: pointer;
      height: 42px;
      line-height: 42px;
      padding: 0 17px;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      i {
        font-size: 18px;
        color: #80848b;
        margin-right: 10px;
        vertical-align: middle;

        &.icon-hot1 {
          &.active {
            color: #fe4509;
          }
        }
      }

      span {
        ::v-deep .key {
          font-style: normal;
          color: #fe4509;
        }
      }

      &.active {
        // color: #0057ff;
        background: #f6f7f9;

        span {
          ::v-deep .key {
            color: #fe4509;
            font-style: normal;
          }
        }
      }

      &:hover {
        background: #f6f7f9;
      }
    }

    p {
      line-height: 1;
      color: #80848b;
      font-size: 14px;
      display: flex;
      margin: 0 17px;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 13px;

      .clear-icon {
        cursor: pointer;
      }

      &.hot-tip {
        &.border-top {
          border-top: 1px solid #e6e7e9;
          padding-top: 20px;
        }
      }
    }

    &::-webkit-scrollbar {
      //设置滚动条宽高
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      // 滚动条轨道样式
      -webhit-box-shadow: inset 0 0 5px transparent;
      border-radius: 0;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      //滚动条样式
      border-radius: 5px;
      margin-right: 2px;
      // -webkit-box-shadow: inset 0 0 5px #242b56;
      background: rgba(0, 0, 0, 0.2);
    }
  }
}

.search-autocomplete {
  li {
    .name {
      font-size: 14px;

      ::v-deep .key {
        font-style: normal;
        color: #0057ff;
      }
    }
  }

  .popper__arrow {
    width: 0;
  }
}

.el-autocomplete-suggestion {
  display: none;
}

.search-input {
  position: absolute;
  right: 4px;
  bottom: 10px;
  width: 280px;
  height: 36px;
  display: inline-block;
  box-sizing: border-box;
  // background: #ffffff;
  // float: right;
  background: #fff;
  border: 1px solid #e6e7e9;
  border-radius: 18px;
  display: flex;
  align-items: center;

  // margin-top: 13px;
  input {
    flex: 1;
    background: #fff;
    outline: none;
    height: 100%;
    padding-left: 18px;
    box-sizing: border-box;
    border-radius: 18px;

    &::-webkit-input-placeholder {
      color: #80848b;
      font-size: 12px;
    }
  }

  .icon-search {
    color: #d8d8d8;
    cursor: pointer;
    margin-right: 16px;
  }
}
</style>
